import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { beforeItems, afterItems } from '../../data/content';
export function Transformation() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-291" data-mp="1nrllyu1oibrw">
      <SectionHeading tone="dark" eyebrow="The transformation" title="From Unpredictable Root Movement to More Confident Torque Planning" lede="The difference between simply moving a crown and understanding the biomechanics behind root movement can change how you approach an entire orthodontic case." data-id="element-292" data-mp="1irg1bxtttpjb" />
      <p className="mx-auto mt-4 max-w-2xl text-center text-base italic text-electric-light" data-id="element-293" data-mp="26m8x29cah5pv">
        “I want you to have a clearer way to evaluate torque mechanics before committing to a treatment plan.”
      </p>

      <div className="mx-auto mt-12 grid max-w-6xl gap-5 md:grid-cols-2 md:gap-6" data-id="element-294" data-mp="2udxx6bvcqyhd">
        <div className="rounded-3xl border border-danger/40 bg-danger/[0.07] p-5 sm:p-8" data-id="element-295" data-mp="2ubuxf04edqzg">
          <h3 className="flex items-center gap-3 font-display text-xl font-extrabold uppercase text-white sm:text-2xl" data-id="element-296" data-mp="158y7x62plezp">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-danger" data-id="element-297" data-mp="wfup0i9ao9xo">
              <XIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-298" data-mp="10hg8wnk8xohd" />
            </span>
            Before the Blueprint
          </h3>
          <ul className="mt-6 space-y-4" data-id="element-299" data-mp="mgnb9tyneda1">
            {beforeItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-snug text-white/80 sm:text-base" data-id="element-300" data-mp="rh1lninq1zb8">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-301" data-mp="dhs2qb84sr3k" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border border-cta/50 bg-cta/[0.08] p-5 sm:p-8" data-id="element-302" data-mp="27vazvjy927oc">
          <h3 className="flex items-center gap-3 font-display text-xl font-extrabold uppercase text-white sm:text-2xl" data-id="element-303" data-mp="2bwmrfv0op2z6">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-304" data-mp="3ku32q1oh84t2">
              <CheckIcon className="h-5 w-5 text-ink" aria-hidden="true" data-id="element-305" data-mp="3ftyvl29gkmfi" />
            </span>
            With the Blueprint
          </h3>
          <ul className="mt-6 space-y-4" data-id="element-306" data-mp="3btey1xkz3gsu">
            {afterItems.map(item => <li key={item} className="flex gap-3 text-[15px] font-medium leading-snug text-white sm:text-base" data-id="element-307" data-mp="36v3prrabtecq">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-308" data-mp="7e5heu2lnn1m" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="text-balance mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold text-white sm:text-2xl" data-id="element-309" data-mp="3uqg5rq5wvv0h">
        You deserve to approach torque planning with a clear clinical strategy — not guesswork.
      </p>
      <SectionCTA label="I want the Torque Control Blueprint" data-id="element-310" data-mp="r4qyk18bj3no" />
    </section>;
}